<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box :title='title' :titleIcon='icon' showAdd @add='openNew'>
            <v-data-table :items='items' :headers='headers' :items-per-page='-1' :loading='is_loading'
              sort-by='action_date' sort-desc hide-default-footer dense>
              <template v-slot:no-data>
                No actions found...
              </template>
              <template v-slot:item.taken_on='{ item }'>
                <div v-if='item.taken_on'>
                  {{ item.action_date | shortDate }}
                  <small class="grey--text">{{ item.taken_on | dateTimeTime }}</small>
                </div>
                <div v-else>
                  {{ item.action_date | shortDate }}
                  <small class="grey--text">{{ item.action_time | time }}</small>
                </div>
              </template>
              <template v-slot:item.taken_by='{ item }'>
                <span v-if='item.taken_by'>{{ item.taken_by_obj.name_display }}</span>
                <span v-if='item.is_system_action'>CPM</span>
              </template>
              <template v-slot:item.description='{ item }'>
                <span v-if='item.description'>{{ item.description }}</span>
              </template>
              <template v-slot:item.action='{ item }'>
                <span v-if='item.action'>{{ item.action }}</span>
              </template>
              <template v-slot:item.options='{ item }'>
                <span v-if='!canEditAction(item)'>
                  <v-tooltip top>
                    <template v-slot:activator='{ on }'>
                      <v-btn small icon v-on='on'>
                        <v-icon color='grey lighten-1'>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Can only edit your actions</span>
                  </v-tooltip>
                </span>
                <span v-else>
                  <v-btn small icon :disabled='!canEditAction(item)' color='orange' @click='openEdit(item)'>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </span>
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <wc-dialog :showDialog='showDialog' :title='title' :icon='icon' @cancel='cancel' @save='updateOrSaveAction'
      :loadingButtons='is_saving' :disableButtons='!isFormValid'>
      <v-form v-model='isFormValid' ref='form'>
        <v-textarea :label='textTitle' v-model='description' :rules='[rules.required]' outlined></v-textarea>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules';
import moment from 'moment';

export default {
  name: 'action-tracker',
  mixins: [formRules],
  props: {
    title: {
      required: false,
      default: 'Action Tracker'
    },
    textTitle: {
      required: false,
      default: 'Reason'
    },
    items: { required: false },
    is_loading: { default: true },
    is_saving: { default: false }
  },
  data: () => ({
    showDialog: false,
    isFormValid: false,
    icon: 'mdi-message-text',
    description: '',
    id: 0,
    action_date: '',

  }),
  computed: {
    headers() {
      return [
        { text: 'Date & Time', value: 'taken_on', width: '230' },
        { text: 'Added By', value: 'taken_by', width: '170' },
        { text: this.textTitle, value: 'description' },
        { text: "Action", value: 'action' },
        { text: '', value: 'options', align: 'right' }
      ]
    },
  },
  methods: {
    cancel() {
      this.showDialog = false;
    },
    openNew() {
      console.log(JSON.parse(JSON.stringify(this.items)))
      console.log("edit")
      this.showDialog = true;
      this.id = 0;
      this.description = '';
      this.$nextTick(() => {
        this.$refs.form.reset()
      });
      this.$nextTick(() => {
        this.action_date = moment().format('YYYY-MM-DD').toString();
      });
    },
    openEdit(item) {
      this.description = item.description;
      this.id = item.id;
      this.action_date = item.action_date;
      this.showDialog = true;
    },
    async updateOrSaveAction() {
      if (this.id !== 0 && this.id !== undefined && this.id !== null) {
        this.updateAction();
      } else {
        this.saveAction();
      }
    },
    async saveAction() {
      const tracker_data = {
        'description': this.description,
        'taken_by': this.$store.state.auth.profile.id,
        'action_date': this.action_date
      }
      this.$emit('save', tracker_data);
      this.showDialog = false;
    },
    async updateAction() {
      const tracker_data = {
        'description': this.description,
        'taken_by': this.$store.state.auth.profile.id,
        'action_date': this.action_date
      }
      this.$emit('update', tracker_data, this.id);
      this.showDialog = false;
    },
    canEditAction(act) {
      return this.$store.state.auth.profile.id === act.taken_by;
    }
  }
}
</script>
